import type { FC } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { LogoBrand } from "@stubhub/broadway-web/icons";
import { Content, useContent } from "src/shared/components/content";
import type { ContentId } from "src/shared/components/content";
import { useAppContext } from "src/shared/context/AppContext";
import {
  CheckMarkContainer,
  CheckMarkIconStyled,
  CheckMarkTextStyled,
  GuaranteeBackground,
  GuaranteeContainer,
  GuaranteeSectionTextContainer,
  GuaranteeSectionTextDiv,
  GuaranteeSectionTitle,
  StyledBrandLogo,
} from "src/website-apps/responsive/stubhub-about-us/components/viagogo/styled-components";
import { Shield as ShieldSvg } from "./assets/Shield";

const CheckMarkIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z" />
  </svg>
);

interface CheckMarkAndTextProps {
  readonly contentId: ContentId;
}

const CheckMarkAndText: FC<CheckMarkAndTextProps> = ({ contentId }) => (
  <CheckMarkContainer>
    <CheckMarkIconStyled>
      <CheckMarkIcon />
    </CheckMarkIconStyled>
    <CheckMarkTextStyled>
      <Content id={contentId} />
    </CheckMarkTextStyled>
  </CheckMarkContainer>
);

export const Guarantee: FC = () => {
  const appContext = useAppContext();
  const isPhone = !useMediaQuery(Breakpoint.Tablet);
  const brandTitle = useContent("cid$#1001316#");

  return (
    <GuaranteeBackground>
      <GuaranteeContainer>
        <GuaranteeSectionTitle>
          <ShieldSvg />
          <StyledBrandLogo
            title={brandTitle}
            brand={LogoBrand.Viagogo}
            url={appContext.homeUrl}
            height={isPhone ? 36 : 75}
          />
          <div>
            <Content id="cid$#2984748#" />
          </div>
        </GuaranteeSectionTitle>
        <GuaranteeSectionTextContainer>
          <GuaranteeSectionTextDiv>
            <CheckMarkAndText contentId="cid$#2984785#" />
            <CheckMarkAndText contentId="cid$#2984784#" />
            <CheckMarkAndText contentId="cid$#2984786#" />
            <CheckMarkAndText contentId="cid$#2984787#" />
          </GuaranteeSectionTextDiv>
        </GuaranteeSectionTextContainer>
      </GuaranteeContainer>
    </GuaranteeBackground>
  );
};
